// import css from "./userCabinet.module.css";
// import { useEffect, useState, useRef } from "react";
// import iconSrc from "../../svg/xCardIcon.svg";
// import { HandySvg } from "handy-svg";
// import {
//   getStorage,
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
// } from "firebase/storage";
// import { db } from "../../firebase";
// import { doc, updateDoc, serverTimestamp, getDoc } from "firebase/firestore";
// import Swal from "sweetalert2";

// export default function ChangeData({
//   scrollHeight,
//   realUser,
//   setCheSetinings,
//   setRealUser,
// }) {
//   const productBigWrapRef = useRef(null);

//   // ---- helpers ----
//   const safeDc = realUser?.deliveryCity ?? null;
//   const isDcObj = safeDc && typeof safeDc === "object";

//   // ---- basic user data ----
//   const [name, setName] = useState(realUser?.displayName || "");
//   const [email, setEmail] = useState(realUser?.email || "");
//   const [tgId, setTgId] = useState(realUser?.telegramId || "");
//   const [phone, setPhone] = useState(realUser?.phone || "");
//   const [file, setFile] = useState(null);

//   // ---- Nova Poshta delivery data ----
//   const [selectedCity, setSelectedCity] = useState(isDcObj ? safeDc : null);
//   const [searchTerm, setSearchTerm] = useState(
//     isDcObj && "Description" in safeDc
//       ? safeDc.Description ?? ""
//       : typeof safeDc === "string"
//       ? safeDc
//       : ""
//   );
//   const [deliveryDepartment, setDeliveryDepartment] = useState(
//     realUser?.deliveryDepartment || ""
//   );

//   // ---- NP API state ----
//   const [novaPoshtaKey, setNovaPoshtaKey] = useState("");
//   const [cities, setCities] = useState([]);
//   const [ulVisible, setUlVisible] = useState(false);
//   const [departments, setDepartments] = useState([]);

//   const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";

//   // position popup
//   useEffect(() => {
//     const el = productBigWrapRef.current;
//     if (el) el.style.top = `${scrollHeight}px`;
//   }, [scrollHeight]);

//   // fetch NP key
//   useEffect(() => {
//     const fetchNovaPoshtaKey = async () => {
//       try {
//         const keyDocRef = doc(db, "novapost", "novaPoshtaData");
//         const keyDocSnap = await getDoc(keyDocRef);
//         if (keyDocSnap.exists()) {
//           setNovaPoshtaKey(keyDocSnap.data()?.key || "");
//         } else {
//           console.log("Документ з ключем Нової Пошти не знайдено.");
//         }
//       } catch (error) {
//         console.error("Помилка завантаження ключа Нової Пошти:", error);
//       }
//     };
//     fetchNovaPoshtaKey();
//   }, []);

//   // локальне завантаження відділень (getWarehouses)
//   const loadDepartmentsForCity = async (cityRef) => {
//     if (!novaPoshtaKey || !cityRef) {
//       setDepartments([]);
//       return;
//     }
//     try {
//       const body = {
//         apiKey: novaPoshtaKey,
//         modelName: "AddressGeneral",
//         calledMethod: "getWarehouses",
//         methodProperties: {
//           CityRef: cityRef,
//           Page: "1",
//           Limit: "500", // щоб підтягнути всі
//           // можна додати: Language: "UA"
//         },
//       };

//       const res = await fetch(NP_API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(body),
//       });

//       const data = await res.json();
//       const list = Array.isArray(data?.data) ? data.data : [];
//       setDepartments(list);
//     } catch (e) {
//       console.error("Помилка завантаження відділень:", e);
//       setDepartments([]);
//     }
//   };

//   // sync local state on realUser changes
//   useEffect(() => {
//     setName(realUser?.displayName || "");
//     setEmail(realUser?.email || "");
//     setTgId(realUser?.telegramId || "");
//     setPhone(realUser?.phone || "");

//     const dc = realUser?.deliveryCity ?? null;
//     const isObj = dc && typeof dc === "object";
//     if (isObj && "Description" in dc) {
//       setSelectedCity(dc);
//       setSearchTerm(dc.Description ?? "");
//     } else {
//       setSelectedCity(null);
//       setSearchTerm(typeof dc === "string" ? dc : "");
//     }

//     setDeliveryDepartment(realUser?.deliveryDepartment || "");
//   }, [realUser]);

//   // при зміні міста — підтягуємо відділення
//   useEffect(() => {
//     if (selectedCity?.Ref) {
//       loadDepartmentsForCity(selectedCity.Ref);
//     } else {
//       setDepartments([]);
//     }
//   }, [selectedCity, novaPoshtaKey]);

//   const closeSet = () => setCheSetinings(false);

//   const showSuccessPopup = () => {
//     Swal.fire({
//       title: "Дані успішно оновлено!",
//       icon: "success",
//       showConfirmButton: false,
//       timer: 1000,
//     }).then(() => setCheSetinings(false));
//   };

//   // save user data
//   const changeDataFunc = async () => {
//     if (!realUser?.uid) return;
//     const userDocRef = doc(db, "users", realUser.uid);

//     const payloadBase = {
//       displayName: name,
//       email: email,
//       telegramId: tgId,
//       phone: phone,
//       deliveryCity: selectedCity ?? null, // зберігаємо тільки об’єкт або null
//       deliveryDepartment: deliveryDepartment || "",
//       updatedAt: serverTimestamp(),
//     };

//     if (file) {
//       try {
//         const storage = getStorage();
//         const storageRef = ref(storage, `users/${realUser.uid}/profile-photo`);
//         const uploadTask = uploadBytesResumable(storageRef, file);

//         uploadTask.on(
//           "state_changed",
//           () => {},
//           (error) => {
//             console.error("Помилка завантаження файлу:", error);
//           },
//           async () => {
//             const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
//             try {
//               await updateDoc(userDocRef, {
//                 ...payloadBase,
//                 photo: downloadURL,
//               });
//               setRealUser((prev) => ({
//                 ...prev,
//                 ...payloadBase,
//                 photo: downloadURL,
//               }));
//               showSuccessPopup();
//             } catch (error) {
//               console.error("Помилка оновлення даних в Firestore:", error);
//             }
//           }
//         );
//       } catch (error) {
//         console.error(
//           "Помилка завантаження зображення в Firebase Storage:",
//           error
//         );
//       }
//       return;
//     }

//     try {
//       await updateDoc(userDocRef, payloadBase);
//       setRealUser((prev) => ({ ...prev, ...payloadBase }));
//       showSuccessPopup();
//     } catch (error) {
//       console.error("Помилка оновлення даних в Firestore:", error);
//     }
//   };

//   // city search
//   const handleCityInputChange = async (event) => {
//     const inputVal = event.target.value;
//     setSearchTerm(inputVal);
//     setUlVisible(true);
//     setSelectedCity(null); // скидаємо, якщо користувач редагує вручну
//     setDepartments([]); // і відділення очищаємо

//     if (!novaPoshtaKey) {
//       console.error("Ключ Нової Пошти не завантажено");
//       return;
//     }
//     if (!inputVal.trim()) {
//       setCities([]);
//       return;
//     }

//     try {
//       const requestData = {
//         apiKey: novaPoshtaKey,
//         modelName: "Address",
//         calledMethod: "getCities",
//         methodProperties: { FindByString: inputVal },
//       };

//       const response = await fetch(NP_API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(requestData),
//       });

//       const data = await response.json();
//       const citiesList = Array.isArray(data?.data) ? data.data : [];
//       setCities(citiesList);
//     } catch (error) {
//       console.error("Error searching cities:", error);
//     }
//   };

//   // pick city
//   const handleCityClick = async (city) => {
//     setSelectedCity(city);
//     setSearchTerm(city?.Description ?? "");
//     setUlVisible(false);
//     setDeliveryDepartment("");
//     await loadDepartmentsForCity(city?.Ref);
//   };

//   return (
//     <div className={css.changeDataWrap} ref={productBigWrapRef}>
//       <div className={css.changeDataWrapSmall}>
//         <div className={css.nameCountWrap}>
//           <h2 className={css.countH2}>Особиста інформація</h2>
//           <HandySvg
//             src={iconSrc}
//             width="28"
//             height="28"
//             className={css.countSvg}
//             onClick={() => setCheSetinings(false)}
//           />
//         </div>

//         <div className={css.inputWrapCard}>
//           {/* Основні дані користувача */}
//           <div className={css.wrapInput}>
//             <p className={css.inputChangeName}>Ім'я</p>
//             <input
//               type="text"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               className={css.inputId}
//             />
//           </div>

//           <div className={css.wrapInput}>
//             <p className={css.inputChangeName}>Email</p>
//             <input
//               type="text"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className={css.inputId}
//             />
//           </div>

//           <div className={css.wrapInput}>
//             <p className={css.inputChangeName}>Телеграм ID</p>
//             <input
//               type="text"
//               value={tgId}
//               onChange={(e) => setTgId(e.target.value)}
//               className={css.inputId}
//             />
//           </div>

//           <div className={css.wrapInput}>
//             <p className={css.inputChangeName}>Телефон</p>
//             <input
//               type="tel"
//               value={phone}
//               onChange={(e) => setPhone(e.target.value)}
//               className={css.inputId}
//             />
//           </div>

//           <div className={css.wrapInput}>
//             <p className={css.inputChangeName}>Фото</p>
//             <input
//               type="file"
//               onChange={(e) => setFile(e.target.files?.[0] || null)}
//               className={css.inputTypesK}
//             />
//           </div>

//           {/* Доставка НП */}
//           <div className={css.deliverySection}>
//             <h3 className={css.sectionTitle}>Адреса доставки (Нова Пошта)</h3>

//             <div className={css.wrapInput}>
//               <p className={css.inputChangeName}>Місто доставки</p>
//               <input
//                 type="text"
//                 placeholder="Введіть місто"
//                 value={searchTerm}
//                 onChange={handleCityInputChange}
//                 className={css.inputId}
//                 onFocus={() => setUlVisible(true)}
//               />
//               {ulVisible && Array.isArray(cities) && cities.length > 0 && (
//                 <ul className={css.dropdownList}>
//                   {cities.map((city, index) => (
//                     <li
//                       key={`${city?.Ref || index}`}
//                       onClick={() => handleCityClick(city)}
//                       className={css.dropdownItem}
//                     >
//                       {city?.SettlementTypeDescription}, {city?.Description},{" "}
//                       {city?.AreaDescription}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>

//             <div className={css.wrapInput}>
//               <p className={css.inputChangeName}>Відділення Нової Пошти</p>
//               <select
//                 className={css.inputId}
//                 value={deliveryDepartment}
//                 onChange={(e) => setDeliveryDepartment(e.target.value)}
//                 disabled={!selectedCity?.Ref}
//               >
//                 {deliveryDepartment ? (
//                   <option value={deliveryDepartment}>
//                     {deliveryDepartment}
//                   </option>
//                 ) : (
//                   <option value="">Оберіть відділення</option>
//                 )}

//                 {Array.isArray(departments) && departments.length > 0 ? (
//                   departments.map((dept, index) => (
//                     <option
//                       key={`${dept?.Ref || index}`}
//                       value={dept?.Description || ""}
//                     >
//                       {dept?.Description || "Відділення"}
//                     </option>
//                   ))
//                 ) : (
//                   <option value="" disabled>
//                     Відділень не знайдено
//                   </option>
//                 )}
//               </select>
//             </div>
//           </div>
//         </div>

//         <button onClick={changeDataFunc} className={css.likeButtonChange}>
//           Оновити дані
//         </button>
//       </div>
//     </div>
//   );
// }
import css from "./userCabinet.module.css";
import { useEffect, useState, useRef } from "react";
import iconSrc from "../../svg/xCardIcon.svg";
import { HandySvg } from "handy-svg";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { db } from "../../firebase";
import { doc, updateDoc, serverTimestamp, getDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import BusinessAddressesManager from "./BusinessAddressesManager"; // ⬅️ НОВИЙ КОМПОНЕНТ

const SALES_FORM_OPTIONS = [
  "Книжкова ятка",
  "Книжковий магазин до 20 м2",
  "Книжковий магазин до 21-40 м2",
  "Книжковий магазин до 40-80 м2",
  "Книжковий магазин більше 80 м2",
  "Мережа книжкових магазинів (більше 2х)",
  "Магазин іграшок",
  "Магазин дитячого одягу",
  "Магазин дитячих товарів",
  "Книжковий інтернет магазин",
  "Інтернет магазин дитячих товарів",
  "Інстаграм книжковий",
  "ФБ книжковий",
  "Інстаграм дитячих товарів",
  "Дропшипінг",
  "Сумісні покупки",
  "Інше",
];

export default function ChangeData({
  scrollHeight,
  realUser,
  setCheSetinings,
  setRealUser,
}) {
  const productBigWrapRef = useRef(null);

  const isBusiness = realUser?.category === "Бізнес-партнер";

  // ---- helpers ----
  const safeDc = realUser?.deliveryCity ?? null;
  const isDcObj = safeDc && typeof safeDc === "object";

  // ---- базові дані (для всіх) ----
  const [email, setEmail] = useState(realUser?.email || "");
  const [tgId, setTgId] = useState(realUser?.telegramId || "");
  const [phone, setPhone] = useState(realUser?.phone || "");
  const [file, setFile] = useState(null);

  // ---- бізнес-дані ----
  const [companyName, setCompanyName] = useState(
    realUser?.companyName || realUser?.displayName || ""
  );
  const [legalForm, setLegalForm] = useState(realUser?.legalForm || "ФОП");
  const [responsibleFio, setResponsibleFio] = useState(
    realUser?.responsibleFio || ""
  );
  const [salesForms, setSalesForms] = useState(
    Array.isArray(realUser?.salesForms) ? realUser.salesForms : []
  );

  // ---- НП дані (використовуються тільки НЕ для бізнес) ----
  const [selectedCity, setSelectedCity] = useState(isDcObj ? safeDc : null);
  const [searchTerm, setSearchTerm] = useState(
    isDcObj && "Description" in safeDc
      ? safeDc.Description ?? ""
      : typeof safeDc === "string"
      ? safeDc
      : ""
  );
  const [deliveryDepartment, setDeliveryDepartment] = useState(
    realUser?.deliveryDepartment || ""
  );

  // ---- NP API state ----
  const [novaPoshtaKey, setNovaPoshtaKey] = useState("");
  const [cities, setCities] = useState([]);
  const [ulVisible, setUlVisible] = useState(false);
  const [departments, setDepartments] = useState([]);
  const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";

  // ---- позиціювання попапу ----
  useEffect(() => {
    const el = productBigWrapRef.current;
    if (el) el.style.top = `${scrollHeight}px`;
  }, [scrollHeight]);

  // ---- fetch NP key ----
  useEffect(() => {
    const fetchNovaPoshtaKey = async () => {
      try {
        const keyDocRef = doc(db, "novapost", "novaPoshtaData");
        const keyDocSnap = await getDoc(keyDocRef);
        if (keyDocSnap.exists()) setNovaPoshtaKey(keyDocSnap.data()?.key || "");
      } catch (e) {
        console.error("Помилка завантаження ключа НП:", e);
      }
    };
    fetchNovaPoshtaKey();
  }, []);

  // ---- sync з realUser ----
  useEffect(() => {
    setEmail(realUser?.email || "");
    setTgId(realUser?.telegramId || "");
    setPhone(realUser?.phone || "");
    setCompanyName(realUser?.companyName || realUser?.displayName || "");
    setLegalForm(realUser?.legalForm || "ФОП");
    setResponsibleFio(realUser?.responsibleFio || "");
    setSalesForms(
      Array.isArray(realUser?.salesForms) ? realUser.salesForms : []
    );

    const dc = realUser?.deliveryCity ?? null;
    const isObj = dc && typeof dc === "object";
    if (isObj && "Description" in dc) {
      setSelectedCity(dc);
      setSearchTerm(dc.Description ?? "");
    } else {
      setSelectedCity(null);
      setSearchTerm(typeof dc === "string" ? dc : "");
    }
    setDeliveryDepartment(realUser?.deliveryDepartment || "");
  }, [realUser]);

  // ---- при зміні міста — підтягуємо відділення (тільки для НЕ бізнес) ----
  useEffect(() => {
    if (isBusiness) return; // бізнес не використовує стандартний блок доставки
    const loadDepartmentsForCity = async (cityRef) => {
      if (!novaPoshtaKey || !cityRef) {
        setDepartments([]);
        return;
      }
      try {
        const body = {
          apiKey: novaPoshtaKey,
          modelName: "AddressGeneral",
          calledMethod: "getWarehouses",
          methodProperties: { CityRef: cityRef, Page: "1", Limit: "500" },
        };
        const res = await fetch(NP_API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        setDepartments(Array.isArray(data?.data) ? data.data : []);
      } catch (e) {
        console.error("Помилка завантаження відділень:", e);
        setDepartments([]);
      }
    };

    if (selectedCity?.Ref) loadDepartmentsForCity(selectedCity.Ref);
    else setDepartments([]);
  }, [selectedCity, novaPoshtaKey, isBusiness]);

  const closeSet = () => setCheSetinings(false);
  const showSuccessPopup = () => {
    Swal.fire({
      title: "Дані успішно оновлено!",
      icon: "success",
      showConfirmButton: false,
      timer: 1000,
    }).then(() => setCheSetinings(false));
  };

  // ---- збереження даних ----
  const changeDataFunc = async () => {
    if (!realUser?.uid) return;
    const userDocRef = doc(db, "users", realUser.uid);

    const payloadBase = {
      email,
      telegramId: tgId,
      phone,
      updatedAt: serverTimestamp(),
    };

    if (isBusiness) {
      Object.assign(payloadBase, {
        companyName: companyName?.trim() || "",
        displayName: companyName?.trim() || "", // щоб інші місця не ламалися
        legalForm,
        responsibleFio: responsibleFio?.trim() || "",
        salesForms: Array.from(new Set(salesForms)),
        // deliveryCity/Department для бізнесу не використовуємо
        deliveryCity: null,
        deliveryDepartment: "",
      });
    } else {
      Object.assign(payloadBase, {
        displayName: realUser?.displayName || companyName || "",
        deliveryCity: selectedCity ?? null,
        deliveryDepartment: deliveryDepartment || "",
      });
    }

    const doUpdate = async (extra = {}) => {
      await updateDoc(userDocRef, { ...payloadBase, ...extra });
      setRealUser((prev) => ({ ...prev, ...payloadBase, ...extra }));
      showSuccessPopup();
    };

    if (file) {
      try {
        const storage = getStorage();
        const storageRef = ref(storage, `users/${realUser.uid}/profile-photo`);
        const uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on(
          "state_changed",
          () => {},
          (error) => console.error("Помилка завантаження файлу:", error),
          async () => {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
            await doUpdate({ photo: downloadURL });
          }
        );
      } catch (error) {
        console.error("Помилка завантаження зображення:", error);
      }
      return;
    }

    try {
      await doUpdate();
    } catch (error) {
      console.error("Помилка оновлення даних в Firestore:", error);
    }
  };

  // ---- пошук міст (для НЕ бізнес) ----
  const handleCityInputChange = async (event) => {
    if (isBusiness) return; // у бізнеса інший механізм адрес
    const inputVal = event.target.value;
    setSearchTerm(inputVal);
    setUlVisible(true);
    setSelectedCity(null);
    setDepartments([]);

    if (!novaPoshtaKey) return;
    if (!inputVal.trim()) return setCities([]);

    try {
      const requestData = {
        apiKey: novaPoshtaKey,
        modelName: "Address",
        calledMethod: "getCities",
        methodProperties: { FindByString: inputVal },
      };
      const response = await fetch(NP_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      setCities(Array.isArray(data?.data) ? data.data : []);
    } catch (error) {
      console.error("Error searching cities:", error);
    }
  };

  const handleCityClick = async (city) => {
    if (isBusiness) return;
    setSelectedCity(city);
    setSearchTerm(city?.Description ?? "");
    setUlVisible(false);
    setDeliveryDepartment("");
  };

  const toggleSalesForm = (label) => {
    setSalesForms((prev) =>
      prev.includes(label) ? prev.filter((x) => x !== label) : [...prev, label]
    );
  };

  return (
    <div className={css.changeDataWrap}>
      <div className={css.changeDataWrapSmall}>
        <div className={css.nameCountWrap}>
          <h2 className={css.countH2}>Налаштування профілю</h2>
          <HandySvg
            src={iconSrc}
            width="28"
            height="28"
            className={css.countSvg}
            onClick={() => setCheSetinings(false)}
          />
        </div>

        <div className={css.inputWrapCard}>
          {/* =====
              БЛОК ОСОБИСТОЇ/БІЗНЕС ІНФОРМАЦІЇ
               ===== */}

          {isBusiness ? (
            <>
              <div className={css.wrapInput}>
                <p className={css.inputChangeName}>Назва (компанії)</p>
                <input
                  type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  className={css.inputId}
                />
              </div>

              <div className={css.wrapInput}>
                <p className={css.inputChangeName}>ЮР. ФОРМА</p>
                <select
                  className={css.inputId}
                  value={legalForm}
                  onChange={(e) => setLegalForm(e.target.value)}
                >
                  <option value="ТОВ">ТОВ</option>
                  <option value="ФОП">ФОП</option>
                  <option value="ІНШЕ">ІНШЕ</option>
                </select>
              </div>

              <div className={css.wrapInput}>
                <p className={css.inputChangeName}>ФІО відповідального</p>
                <input
                  type="text"
                  value={responsibleFio}
                  onChange={(e) => setResponsibleFio(e.target.value)}
                  className={css.inputId}
                />
              </div>

              <div className={css.wrapInput}>
                <p className={css.inputChangeName}>ФОРМА ПРОДАЖУ</p>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 8,
                  }}
                >
                  {SALES_FORM_OPTIONS.map((label) => (
                    <label
                      key={label}
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <input
                        type="checkbox"
                        checked={salesForms.includes(label)}
                        onChange={() => toggleSalesForm(label)}
                      />
                      <span>{label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <>
              {/* НЕ бізнес: показуємо Ім'я + стандартну доставку */}
              <div className={css.wrapInput}>
                <p className={css.inputChangeName}>Ім'я</p>
                <input
                  type="text"
                  value={realUser?.displayName || ""}
                  onChange={(e) =>
                    setRealUser((prev) => ({
                      ...prev,
                      displayName: e.target.value,
                    }))
                  }
                  className={css.inputId}
                />
              </div>
            </>
          )}

          {/* Загальні поля (для всіх ролей) */}
          <div className={css.wrapInput}>
            <p className={css.inputChangeName}>Email</p>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={css.inputId}
            />
          </div>
          <div className={css.wrapInput}>
            <p className={css.inputChangeName}>Телеграм ID</p>
            <input
              type="text"
              value={tgId}
              onChange={(e) => setTgId(e.target.value)}
              className={css.inputId}
            />
          </div>
          <div className={css.wrapInput}>
            <p className={css.inputChangeName}>Телефон</p>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className={css.inputId}
            />
          </div>
          <div className={css.wrapInput}>
            <p className={css.inputChangeName}>Фото</p>
            <input
              type="file"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
              className={css.inputTypesK}
            />
          </div>

          {/* Доставка: бізнес має власний менеджер адрес, інші — стандартний блок НП */}
          {isBusiness ? (
            <div className={css.deliverySection}>
              <h3 className={css.sectionTitle}>
                Адреси доставки бізнес‑клієнта
              </h3>
              <BusinessAddressesManager
                uid={realUser?.uid}
                novaPoshtaKey={novaPoshtaKey}
              />
            </div>
          ) : (
            <div className={css.deliverySection}>
              <h3 className={css.sectionTitle}>Адреса доставки (Нова Пошта)</h3>
              <div className={css.wrapInput}>
                <p className={css.inputChangeName}>Місто доставки</p>
                <input
                  type="text"
                  placeholder="Введіть місто"
                  value={searchTerm}
                  onChange={handleCityInputChange}
                  className={css.inputId}
                  onFocus={() => setUlVisible(true)}
                />
                {ulVisible && Array.isArray(cities) && cities.length > 0 && (
                  <ul className={css.dropdownList}>
                    {cities.map((city, index) => (
                      <li
                        key={`${city?.Ref || index}`}
                        onClick={() => handleCityClick(city)}
                        className={css.dropdownItem}
                      >
                        {city?.SettlementTypeDescription}, {city?.Description},{" "}
                        {city?.AreaDescription}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className={css.wrapInput}>
                <p className={css.inputChangeName}>Відділення Нової Пошти</p>
                <select
                  className={css.inputId}
                  value={deliveryDepartment}
                  onChange={(e) => setDeliveryDepartment(e.target.value)}
                  disabled={!selectedCity?.Ref}
                >
                  {deliveryDepartment ? (
                    <option value={deliveryDepartment}>
                      {deliveryDepartment}
                    </option>
                  ) : (
                    <option value="">Оберіть відділення</option>
                  )}
                  {Array.isArray(departments) && departments.length > 0 ? (
                    departments.map((dept, index) => (
                      <option
                        key={`${dept?.Ref || index}`}
                        value={dept?.Description || ""}
                      >
                        {dept?.Description || "Відділення"}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      Відділень не знайдено
                    </option>
                  )}
                </select>
              </div>
            </div>
          )}
        </div>

        <button onClick={changeDataFunc} className={css.likeButtonChange}>
          Оновити дані
        </button>
      </div>
    </div>
  );
}
